import {
  inject,
  Injectable,
  makeStateKey,
  Pipe,
  PipeTransform,
  TransferState,
} from '@angular/core';

@Pipe({
  name: 'assetsUrl',
})
@Injectable({
  providedIn: 'root',
})
export class AssetsUrlPipe implements PipeTransform {
  private readonly ASSETS_PATH_KEY = makeStateKey<string>('assets_path');

  private transferState = inject(TransferState);

  transform(resourcePath?: string): string {
    return resourcePath
      ? `${this.getAssetsPath()}/assets/resources/${resourcePath}`
      : '';
  }

  getAssetsPath(): string {
    return this.transferState.get(this.ASSETS_PATH_KEY, '');
  }
}
